const PAYMENT_BANK_SCB = 'SCB';

const PAYMENT_METHOD_2C2P = '2c2p';
const PAYMENT_METHOD_BANKTRANSFER = 'banktransfer';
const PAYMENT_METHOD_OMISE = 'omise';
const PAYMENT_METHOD_SO = 'so'

const paymentBankTagColor = {};
paymentBankTagColor[PAYMENT_BANK_SCB] = '#472279';

const paymentMethodTagColor = {};
paymentMethodTagColor[PAYMENT_METHOD_2C2P] = '#014a56';
paymentMethodTagColor[PAYMENT_METHOD_BANKTRANSFER] = '#472279';
paymentMethodTagColor[PAYMENT_METHOD_OMISE] = '#3068f8';
paymentMethodTagColor[PAYMENT_METHOD_SO] = '#e28743'

const paymentMethodTagName = {};
paymentMethodTagName[PAYMENT_METHOD_2C2P] = '2C2P';
paymentMethodTagName[PAYMENT_METHOD_BANKTRANSFER] = 'Bank Transfer';
paymentMethodTagName[PAYMENT_METHOD_OMISE] = 'Omise';
paymentMethodTagName[PAYMENT_METHOD_SO] = 'SO'

const getPaymentBankTagColor = (bank) => {
  return paymentBankTagColor[bank] || '#f0f0f0';
};

const getPaymentMethodTagColor = (method) => {
  return paymentMethodTagColor[method] || '#f0f0f0';
};

const getPaymentMethodTagName = (method) => {
  return paymentMethodTagName[method] || '-';
};

export {
  getPaymentMethodTagColor,
  getPaymentMethodTagName,
  PAYMENT_METHOD_BANKTRANSFER,
  getPaymentBankTagColor,
};



// WEBPACK FOOTER //
// ./src/config/payment.js